"use client";
import CPaginationWithLinksSkeleton from "@/components/main/CPaginationWithLinksSkeleton";
import OrganizationCardSkeleton from "@/components/web/main/organizations/OrganizationCardSkeleton";
import OrganizationSmallCardSkeleton from "@/components/web/main/organizations/OrganizationSmallCardSkeleton";
import { Container, Grid, Skeleton } from "@mantine/core";

const loading = () => {
  return (
    <>
      <Container>
        <div className="flex justify-between items-center mt-[35px] mb-[26px]">
          <Skeleton height={20} width={138} />
          <Skeleton height={44} width={181} />
        </div>
        <Grid>
          {Array.from(Array(10).keys()).map((organization, index) => (
            <Grid.Col span={12} md={12} lg={6} p={0} key={index}>
              <div className="hidden lg:block">
                <OrganizationCardSkeleton className="m-2" />
              </div>
              <div className="block lg:hidden">
                <OrganizationSmallCardSkeleton className="m-2" />
              </div>
            </Grid.Col>
          ))}
        </Grid>
        <CPaginationWithLinksSkeleton />
      </Container>
    </>
  );
};

export default loading;
